module.exports = __webpack_public_path__ + "static/img/background-2.878e2e1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/background-2.jpg
// module id = LS5v
// module chunks = 0